/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：479
 */

module.exports = function (e) {
  var t = typeof e
  return null != e && ("object" == t || "function" == t)
}
